export default {
	error1: 'Errors in first name/last name',
	error2: 'Please read and consent to the User Agreement and Privacy Policy',
	error3: 'Please fill in the phone number',
	error4: 'Please check the email',
	error5: 'Please select grade and subject',
	error6: 'System error. Try again',
	firstName: 'First Name',
	yFirstName: 'Your First Name',
	lastName: 'Last Name',
	yLastName: 'Your Last Name',
	grade: 'Grade',
	yGrade: 'Your Grade',
	search: 'Search',
	subject: 'Subject',
	ySubject: 'Your Subject',
	consentTo: 'Consent to ',
	requestNow: 'Request Now!',
	searchText: 'Select Country or Region',
	phoneImg: 'https://web-data.zmlearn.com/image/hdmwQMexSmDZVT2FrLi2af/img_popup_request02%402x.png',
	pcImg: 'https://web-data.zmlearn.com/image/a3YmG9D6q4fRrVyfGP6njt/img_popup_request%402x.png',
	title: 'Get a free trial session with AirClass',
	agreeToReceive: 'Consent to receive your promotion emails and SMS',
	disagreePrompt: 'You need to agree to all our terms before sign up',
	serviceLanaguage:'Preferred Customer Service Language',
	serviceLanaguageP:'Please select',
};
